import { Link, Text } from '@factorialco/deprecated-design-system'

import DescriptionBox from 'modules/payroll_bundle/components/ChangeStatusButton/StatusModal/DescriptionBox'

interface WarningBannerProps {
  action: string
  description: string
  onClickAction: () => void
}

const WarningBanner = ({ action, description, onClickAction }: WarningBannerProps) => {
  return (
    <DescriptionBox>
      <Text size="200">{description}</Text>
      <Link.Touchable onClick={onClickAction}>{action}</Link.Touchable>
    </DescriptionBox>
  )
}

export default WarningBanner
